import { Stack } from "@mui/material";

import type { UploadProgressProps } from "./types";

import {
  FancyProgressBar,
  FancyProgressWrapper,
  ProgressText,
} from "./UploadStyles/UploadProgressStyles";

export function UploadProgress({ value, loading }: UploadProgressProps) {
  if (!loading) return null;

  return (
    <Stack
      spacing={1.5}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        width: "100%",
        py: 2,
      }}
    >
      <FancyProgressWrapper>
        <FancyProgressBar variant="determinate" value={value} />
      </FancyProgressWrapper>
      <ProgressText>{value}%</ProgressText>
    </Stack>
  );
}
